import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import { appDomain, appEmit } from "../../domain/AppDomain";
import { EventNames } from "../../domain/events/Events";
import { ICalendar } from "../../domain/calendars/ICalendar";
import { ICalendarEvent } from "../../domain/calendars/ICalendarEvent";
import { dateAdd } from "../../helpers/dateHelpers";
import { BaseComponent } from "../core/BaseComponent";

interface AbsenceDayRowProps {
    calendar: ICalendar;
    date: Date;
    smallRow: boolean;
}

interface AbsenceDayRowState {
    editEvent?: ICalendarEvent;
}

export class AbsenceDayRow extends BaseComponent<AbsenceDayRowProps, AbsenceDayRowState> {
    state = { editEvent: undefined };
    getTimeOfDayHours(date: Date) {
        return date.getHours() + (date.getMinutes() / 60)
    }
    getAbsence(a: ICalendarEvent, toggleEdit: (event: ICalendarEvent) => void, index: string): JSX.Element {
        let time = `${format(a.start, "HH:mm")} - ${format(a.end, "HH:mm")}`;
        let until = "";
        // const startHour = this.getTimeOfDayHours(a.start);
        const endHour = this.getTimeOfDayHours(a.end);
        const diffInHours = (a.end.getTime() - a.start.getTime()) / 1000 / 60 / 60;

        if (a.isEntireDay || diffInHours > 24) {
            time = "";
        }

        var startDate = format(a.start, "dd-MM");
        var endDate = format(a.end, "dd-MM");
        if (endHour < 6) {
            endDate = format(dateAdd(a.end, (endHour + 1) * -60 * 60 * 1000), "dd-MM");
        }

        if (startDate !== endDate) {
            until = "t/m " + endDate;
        }

        const absenceDescription = `${time} ${a.description} ${until}`;

        const classes = ["cal-event"];
        let editBtn = null;
        if (a.oid) {
            classes.push("editable");
            editBtn = <span className="btn btn-edit" onClick={() => toggleEdit(a)}><FontAwesomeIcon icon={faEdit} /></span>
        }

        return <div key={index} className={classes.join(" ")} title={absenceDescription}>{absenceDescription} {editBtn}</div>;
    }

    editEvent(calendar: ICalendar, event: ICalendarEvent) {
        appEmit(EventNames.editAbsence, { calendar, event });
    }

    render() {
        const calendar = this.props.calendar;
        const status = calendar.status;
        const addNewAbsence = () => () => this.editEvent(calendar, {} as ICalendarEvent);
        const getEditAbsence = (a: ICalendarEvent) => () => this.editEvent(calendar, a); // (event: ICalendarEvent) => this.setState({ editEvent: { ...event } }); // copy event to prevent reset on reload
        let statusDescription = "";
        let statusClass = "";
        let employeeName = calendar.name;
        statusClass = appDomain.IEmployeeAbsenceService.getAbsenceClass(status);
        statusDescription = this.translate(`absence.employeeabsencestatus.${calendar.status}`);

        const absencesList = this.props.smallRow ? [] : calendar.calendarEvents.map((a, i) => this.getAbsence(a, getEditAbsence(a), i.toString()));

        let count = absencesList.length;
        let meeting = "";
        if (calendar.meetingEnd) {
            meeting = ` (in overleg tot ${(calendar.meetingEnd || "").slice(0, 5)})`;
            count += 1;
        }
        const smallRowClass = this.props.smallRow ? 'small-row' : '';
        return (
            <div key={this.props.calendar.id} className={`employee-absence-day ${statusClass} ${smallRowClass}`}
                style={{ height: (Math.max(2, count) * 15) + "px" }}>
                <div className="name">{employeeName} </div>
                <div className="status  a-tooltip">
                    <span className="tooltiptext right">{statusDescription}</span>
                </div>
                <div
                    className={"absences " + (count > 1 ? "multi-absences" : "single-absences")}
                >{meeting} {absencesList}</div>
                <div className="btn btn-add" onClick={addNewAbsence()}><FontAwesomeIcon icon={faPlus} /></div>
            </div >);
    }
}
